import styles from './Text.module.css'
import cx from "classnames";

type TextProps = {
    children: string | JSX.Element,
    classes?: string
}

const Text = ({children, classes}: TextProps) => {
    return (
        <p className={cx(styles['zr-text'], classes)}>{children}</p>
    )
}

export default Text;
